module.exports = fox._r("images/gallery/icons@2x.png", __webpack_public_path__ + "_/_/_/root/images/gallery/icons@2x.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/gallery/icons@2x.png
// module id = 412
// module chunks = 4